var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSortDescending = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.932 14.222 3.716 18 .5 14.222h2.297V1.944c0-.521.412-.944.92-.944.507 0 .918.423.918.944v12.278h2.297Zm.46-12.278c0-.521.411-.944.919-.944h8.27c.508 0 .919.423.919.944v.945a.932.932 0 0 1-.919.944h-8.27a.932.932 0 0 1-.92-.944v-.945Zm2.757 3.778a.932.932 0 0 0-.92.945v.944c0 .522.412.945.92.945h6.432a.932.932 0 0 0 .919-.945v-.944a.932.932 0 0 0-.919-.945H10.15Zm.919 5.667c0-.522.411-.945.918-.945h4.595c.508 0 .919.423.919.945v.944a.932.932 0 0 1-.919.945h-4.595a.932.932 0 0 1-.918-.945v-.944Zm2.756 3.778a.932.932 0 0 0-.919.944v.945c0 .521.412.944.92.944h2.756a.932.932 0 0 0 .919-.944v-.945a.932.932 0 0 0-.919-.944h-2.757Z",
  clipRule: "evenodd"
})));
export default SvgIconSortDescending;